export enum AutomationStatus {
  Draft = "draft",
  Active = "active",
  Inactive = "inactive",
}
